export default __webpack_public_path__ + "static/media/cameraBack.0e214a26.png";